// extracted by mini-css-extract-plugin
export var alertIcon = "_uc-0";